import { ExternalUserStatus } from '../../enums/ExternalUserStatus';
import { StateStatus } from '../../enums/StateStatus';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { UserRoleType } from '../user/types';

export enum InternalUserFilter {
  SystemAdmin = 'SystemAdmin',
  ReadAll = 'ReadAll',
  Empty = 'Empty',
  All = 'All'
}

export enum UserAccountOption {
  Block = 'Block',
  Unblock = 'Unblock'
}
export interface UsersState {
  internalUsers: InternalUser[] | null;
  externalUsers: ExternalUser[] | null;
  status: StateStatus;
  error: RestErrorResponse | null;
  externalUserProfileDetails: ExternalUserProfileDetails | null;
}

export interface InternalUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  mobilePhoneNumber: string;
  phoneNumber: string;
  areaName: string;
  roleName: UserRoleType;
  title: string;
  profilePhoto: string;
}

export interface ExternalUser {
  id: number;
  email: string;
  name: string;
  mobilePhoneNumber: string;
  phoneNumber: string;
  active: boolean;
  createdOn: string;
  status: number;
  statusEnum: ExternalUserStatus;
  invitedBy: string;
}

export interface ExternalUserProfileDetails {
  id: number;
  email: string;
  name: string;
  mobilePhoneNumber: string;
  phoneNumber: string;
  addressLine1: string;
  postCode: string;
  city: string;
  lang: string;
}
